import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SequenceService {

  constructor(private api: ApiService) { }

  createSequence(data:any): Observable<any> {
    return this.api.post(environment.createSequence,data);
  }

  updateSequence(data:any): Observable<any> {
    return this.api.post(environment.updateSequence,data);
  }

  updateSequenceCounter(data:any): Observable<any> {
    return this.api.post(environment.updateSequenceCounter,data);
  }

  getSequence(data:any): Observable<any> {
    return this.api.post(environment.getSequence,data);
  }

  getAllSequence(data:any): Observable<any> {
    return this.api.post(environment.getAllSequence,data);
  }

  createSequenceSchedule(data:any): Observable<any> {
    return this.api.post(environment.createSequenceSchedule,data);
  }

  updateSequenceSchedule(data:any): Observable<any> {
    return this.api.post(environment.updateSequenceSchedule,data);
  }

  getSequenceSchedule(data:any): Observable<any> {
    return this.api.post(environment.getSequenceSchedule,data);
  }

  getAllSequenceSchedule(data:any): Observable<any> {
    return this.api.post(environment.getAllSequenceSchedule,data);
  }

  createSequenceTask(data:any): Observable<any> {
    return this.api.post(environment.createSequenceTask,data);
  }

  updateSequenceTask(data:any): Observable<any> {
    return this.api.post(environment.updateSequenceTask,data);
  }

  getSequenceTask(data:any): Observable<any> {
    return this.api.post(environment.getSequenceTask,data);
  }

  getAllSequenceTask(data:any): Observable<any> {
    return this.api.post(environment.getAllSequenceTask,data);
  }   
  
  getAllSequenceWithCount(data:any): Observable<any> {
    return this.api.post(environment.getAllSequenceWithCount,data);
  } 

  getAllSequenceTaskWithCount(data:any): Observable<any> {
    return this.api.post(environment.getAllSequenceTaskWithCount,data);
  } 

  deleteSequenceTask(data:any): Observable<any> {
    return this.api.post(environment.deleteSequenceTask,data);
  }

  deleteSequence(data:any): Observable<any> {
    return this.api.post(environment.deleteSequence,data);
  }

  checkForMailConfigConnection(data:any): Observable<any> {
    return this.api.post(environment.checkForMailConfigConnection,data);
  }
}


